import { createTheme } from "@mui/material/styles";

const colors = {
  primary: {
    light: "#fdfdfd",
    main: "#373437",
    other: "#f39200",
    dark: "#000000",
  },
  secondary: {
    light: "#e3f2fd",
    main: "#f39200",
    dark: "#2978a0",
  },
  error: {
    light: "#ef5350",
    main: "#d32f2f",
    dark: "#c62828",
  },
  warning: {
    light: "#ff9800",
    main: "#ed6c02",
    dark: "#e65100",
  },
  info: {
    light: "#03a9f4",
    main: "#0288d1",
    dark: "#01579b",
  },
  success: {
    light: "#4caf50",
    main: "#2e7d32",
    dark: "#1b5e20",
  },
  dark: {
    main: "#52595b",
  }
};

//Kreiranje varijanti za MUI komponentu Button

const proluxTheme = createTheme({
  palette: {
    //type: "dark", promena teme
    primary: {
      light: colors.primary.light,
      main: colors.primary.main,
      other: colors.primary.other,
      dark: colors.primary.dark,
    },
    secondary: {
      light: colors.secondary.light,
      main: colors.secondary.main,
      dark: colors.secondary.dark,
    },
    error: {
      light: colors.error.light,
      main: colors.error.main,
      dark: colors.error.dark,
    },
    warning: {
      light: colors.warning.light,
      main: colors.warning.main,
      dark: colors.warning.dark,
    },
    info: {
      light: colors.info.light,
      main: colors.info.main,
      dark: colors.info.dark,
    },
    success: {
      light: colors.success.light,
      main: colors.success.main,
      dark: colors.success.dark,
    },
    dark: {
      main: colors.dark.main,
    }
  },
  typography: {
    fontFamily: "Montserrat",
  },
  components: {
    root: {
      display: "flex",
      flexFlow: "column",
      height: "100vh",
    },
    MuiAppBar: {
      styleOverrides: {
        // Name of the slot
        root: {
          position: "static",
          background: colors.secondary.main,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "normal",
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          //background: colors.secondary.main,
        },
      },
    },
  },
});

export default proluxTheme;
